import { convertDateStringToArray } from "../utilities/shipmentTable";
import axiosInstance from "./axios";
import config from "./config";
import moment from "moment";

export const fetchMetrics = async (
	selectedDate,
	CustomerId,
	CustomerRegion,
	DeliveryStatus,
	City,
	Warehouse,
	reschedule,
	autoRecovery,
	userDetails
) => {
	try {
		const isCustomerUser = userDetails.isCustomerUser === true;
		const dateArray = convertDateStringToArray(selectedDate) || [moment().format("YYYYMMDD")];
		
		const params = {
			SelectedDate: dateArray,
			CustomerRegion: CustomerRegion || "",
			DeliveryStatus: DeliveryStatus || "",
			City: City || "",
			warehouse: Warehouse || "",
			reschedule: reschedule || false,
			autoRecovery: autoRecovery || false,
		};

		// UPDATED: Only send CustomerId for Niagara users (not customer users)
		// Customer users' filtering will be handled automatically by backend
		if (!isCustomerUser && CustomerId) {
			params.CustomerId = CustomerId;
		}

		const response = await axiosInstance.get(`${config.endpoints.metrics_url}`, { params });
		return response.data;
	} catch (error) {
		console.error("Error fetching metrics:", error);
		throw error;
	}
};
